import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DesifarmAck } from 'src/app/models/desifarm-common/desifarmAck';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DesifarmBannerImagesService {

  constructor(private http: HttpClient) { }

  get_banner_images(District_Id): Observable<any> {
    return this.http.post<DesifarmAck>(environment.url + 'get_banner_images', { Use_In: "Web", Business_Type_Id: environment.Business_Type_Id, District_Id: District_Id })
  }

  getHomepageOffer(District_Id): Observable<any> {
    return this.http.get<DesifarmAck>(`${environment.url}getHomepageOffer/${environment.Business_Type_Id}/${District_Id}`)
    // return this.http.get<DesifarmAck>(environment.url + 'getHomepageOffer/' + environment.Business_Type_Id)
  }
}
